import React from 'react';
import { defineMessages } from 'react-intl';
import { generatePath } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import apiConfig from '@constants/apiConfig';
import { errorCodes } from '@constants/ErrorCode';
import useSaveBase from '@hooks/useSaveBase';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import PrinterMappingForm from '@modules/digibesShop/Devices/tabs/kitplay/tabs/PrinterMapping/PrinterMappingForm';
import routes from '@routes';
import { showErrorMessage } from '@services/notifyService';

const message = defineMessages({
    objectName: 'Printer mapping',
});

const PrinterMappingSavePage = () => {
    const translate = useTranslate();

    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get('tab');
    const printerId = queryParams.get('printerId');
    const restaurantId = queryParams.get('restaurantId');
    const restaurantName = queryParams.get('restaurantName');
    const ordering = queryParams.get('ordering');
    const collapseId = queryParams.get('collapseId');

    const { detail, mixinFuncs, loading, setIsChangedFormValues, isEditing, title, setSubmit } = useSaveBase({
        apiConfig: apiConfig.printerMapping,
        options: {
            getListUrl: `${generatePath(routes.resDeviceTabsRestaurantListPage.path)}?tab=${tab}&restaurantId=${restaurantId}&restaurantName=${restaurantName}&collapseId=${collapseId}`,
            objectName: translate.formatMessage(message.objectName),
        },
        override: (funcs) => {
            funcs.prepareUpdateData = (data) => {
                return {
                    ...data,
                    id: detail.id,
                    printerId,
                };
            };
            funcs.prepareCreateData = (data) => {
                return {
                    ...data,
                    printerId,
                    ordering: ordering ? Number(ordering) : undefined,
                };
            };
            funcs.onSaveError = (err) => {
                const errorCode = err.response?.data?.code;
                const errorMessage = errorCodes[errorCode]?.message;
                if (errorMessage) {
                    showErrorMessage(errorMessage, translate);
                    setSubmit(false);
                } else {
                    mixinFuncs.handleShowErrorMessage(err, showErrorMessage);
                    setSubmit(false);
                }
            };
        },
    });

    return (
        <PageWrapper
            loading={loading}
            routes={[
                {
                    breadcrumbName: translate.formatMessage(commonMessage.restaurant),
                    path: generatePath(routes.restaurantListPage.path),
                },
                {
                    breadcrumbName: restaurantName || translate.formatMessage(commonMessage.devices),
                    path: `${generatePath(routes.resDeviceTabsRestaurantListPage.path)}?tab=${tab}&restaurantId=${restaurantId}&restaurantName=${restaurantName}&collapseId=${collapseId}`,
                },
                { breadcrumbName: title },
            ]}
            title={title}
        >
            <PrinterMappingForm
                setIsChangedFormValues={setIsChangedFormValues}
                dataDetail={detail ? detail : {}}
                formId={mixinFuncs.getFormId()}
                isEditing={isEditing}
                actions={mixinFuncs.renderActions()}
                onSubmit={mixinFuncs.onSave}
            />
        </PageWrapper>
    );
};

export default PrinterMappingSavePage;
